/**
 * Created by felix on 29/07/2022.
 */

import Vue from 'vue';

import {EMPTY, READY, LOADING, UPDATING, ERROR} from 'module/constants';
import common from 'module/common';
import {mapFieldMutation} from 'module/mapField';
import Moment from "moment/moment";

const SET_STATE = 'setState';
const SET_STATS = 'setStats';
const SET_TYPE = 'setType';
const SET_CONFIG = 'setConfig';
const SET_KEY = 'setKey';
const SET_OPERATION_COMPLETION = 'setOperationCompletion';
const SET_MAIN_MODAL_TEXT = 'setMainModalText';
const SET_MAIN_MODAL_ACTIVE = 'setMainModalActive';
const SET_MAIN_MODAL_RESPONSE = 'setMainModalResponse';
const SET_SHOW_SEARCH_BAR = 'showSearchBar';
const SET_IS_DOWNLOADING = 'isDownloading';
const SET_CURSOR_STYLE = 'cursorStyle';
const SET_INTERNAL_SUPPLIERS = 'internalSuppliers';
const SET_GOOGLE_IDS_FOR_ADVERTS = 'setGoogleIdsForAdverts';

// initial state
const state = {
  operationCompletion: 0,
  state: EMPTY,
  configType: null,
  mainModalText: null,
  mainModalActive: false,
  mainModalResponse: null,
  cursorStyle: 'auto',
  config: {
    turnaround: 0,
    steelPrice: 0,
    programs: []
  },
  showSearchBar: false,
  isDownloading: false,
  key: null,
  stats: {},
  internalSuppliers: [],
  googleIds: [],
};

//actions
const actions = {
  updateConfig({commit, dispatch}, {configType, configId, valuesToUpdate}) {
    return dispatch('save', {
      action: 'updateConfig',
      data: {
        configId: configId,
        valuesToUpdate: valuesToUpdate,
        type: configType
      }
    });
  },
  fetchConfig({commit, dispatch, rootGetters}, {configType, configKey}) {
    return new Promise((resolve, reject) => {
      commit(SET_STATE, LOADING);
      commit(SET_TYPE, configType);

      const query = {
        type: configType,
        configKey: configKey
      }

      common
        .httpGet('config')
        .idToken(rootGetters['user/idToken']() || null)
        .query(query)
        .then((res) => {
          commit(SET_STATE, READY);
          commit(SET_CONFIG, res.data);
          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_STATE, ERROR);
          reject();
        });
    });
  },
  fetchStats({commit, dispatch, rootGetters}, statsType) {
    return new Promise((resolve, reject) => {
      commit(SET_STATE, LOADING);

      let data = {
        stats: statsType,
        idToken: rootGetters['user/idToken'](),
      };

      common
        .httpPost('stats')
        .data(data)
        .then((res) => {
          commit(SET_STATE, READY);
          commit(SET_STATS, res.data);
          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_STATE, ERROR);
          reject();
        });
    });
  },
  requestExport({commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      common
        .httpPost('search')
        .data(data)
        .then((res) => {
          commit(SET_MAIN_MODAL_TEXT, 'Your export request has been recorded, you will receive an ' +
            "email with the data in the next 30 minutes. Please check your junk folder too and if you didn't receive it," +
            ' please raise an issue with the Dev Team. Thank you.');
          commit(SET_MAIN_MODAL_ACTIVE, true);
          resolve(res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
          reject();
        });
    });
  },
  requestReport({commit, dispatch, rootGetters}, {reportType, reportOptions, startDate, endDate, app}) {
    return new Promise((resolve, reject) => {

      let data = {
        reportType: reportType,
        reportOptions: reportOptions,
        startDate: startDate,
        endDate: endDate,
        app: app,
        idToken: rootGetters['user/idToken'](),
      };

      common
        .httpPost('report')
        .data(data)
        .then((res) => {
          commit(SET_MAIN_MODAL_TEXT, 'Your report request has been recorded, you will receive an ' +
            "email with the data in the next 30 minutes. Please check your junk folder too and if you didn't receive it," +
            ' please raise an issue with the Dev Team. Thank you.');
          commit(SET_MAIN_MODAL_ACTIVE, true);
          resolve(res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
          reject();
        });
    });
  },
  getAvailableInternalSuppliers({commit, dispatch, rootGetters}) {
    return new Promise((resolve, reject) => {

      common
        .httpGet('product')
        .idToken(rootGetters['user/idToken']() || null)
        .then((res) => {
          commit(SET_INTERNAL_SUPPLIERS, res.data);
          resolve(res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
          reject();
        });
    });
  },
  branchFeedback({commit, dispatch}, {feedback,userName,userEmail}) {
    return new Promise((resolve, reject) => {
      let data = {
        action: 'branchFeedback',
        feedback: feedback,
        userName: userName ,
        userEmail:userEmail,
      }

      common
        .httpPost('branch')
        .data(data)
        .then((res) => {
          resolve(res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
          reject();
        })
    })
  },
  helpDesk({commit, dispatch}, {teamViewerId,teamViewerPassword,projectRef, issueType, issueDescription,dropFiles}) {

    return new Promise((resolve, reject) => {
      let data = {
        action: 'helpDesk',
        teamViewerId: teamViewerId,
        teamViewerPassword: teamViewerPassword ,
        projectRef:projectRef,
        issueType:issueType,
        issueDescription: issueDescription,
        dropFiles: dropFiles
      }

      common
        .httpPost('config')
        .data(data)
        .then((res) => {
          resolve(res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
          reject();
        })
    })

  },
  coPilotAdverts({commit, dispatch, rootGetters}) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await common.httpPost('coPilotAdverts').data({
          action: 'getCoPilotAdverts',
          idToken: rootGetters['user/idToken']()
        });  // Await the HTTP GET request
        commit(SET_GOOGLE_IDS_FOR_ADVERTS, res.data);  // Commit on success
        resolve(res);  // Resolve the promise with the result
      } catch (error) {
        dispatch('error/error', error, {root: true});  // Handle error
        reject(error);  // Reject the promise with the error
      }
    });
  },
  save({commit, dispatch, state, rootGetters}, {route, action, data}) {
    return new Promise((resolve, reject) => {
      commit(SET_STATE, UPDATING);

      data = _.merge({
        idToken: rootGetters['user/idToken'](),
        action,
        route
      }, data);

      common
        .httpPost('config')
        .data(data)
        .then((res) => {
          commit(SET_STATE, READY);
          commit(SET_CONFIG, res.data);
          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_STATE, ERROR);
          reject();
        });
    });
  }
};

// mutations
const mutations = {
  [SET_STATE](state, newState) {
    state.state = newState;
  },
  [SET_OPERATION_COMPLETION](state, operationCompletionPercentage) {
    state.operationCompletion = operationCompletionPercentage;
  },
  [SET_STATS](state, stats) {
    _.forEach(stats, (entry, key) => {
      state.stats[key] = entry;
    })
  },
  [SET_TYPE](state, type) {
    state.configType = type;
  },
  [SET_CONFIG](state, config) {
    _.forEach(config, (entry, key) => {
      if (key !== '_id') {
        state.config[key] = entry;
      }
    })
  },
  [SET_KEY](state, key) {
    state.key = key;
  },
  [SET_MAIN_MODAL_TEXT](state, text) {
    state.mainModalText = text;
  },
  [SET_MAIN_MODAL_ACTIVE](state, activeValue) {
    state.mainModalActive = activeValue;
  },
  [SET_MAIN_MODAL_RESPONSE](state, response) {
    state.mainModalResponse = response;
  },
  [SET_SHOW_SEARCH_BAR](state, showSearchBar) {
    state.showSearchBar = showSearchBar;
  },
  [SET_IS_DOWNLOADING](state, isDownloading) {
    state.isDownloading = isDownloading;
  },
  [SET_CURSOR_STYLE](state, cursorStyle) {
    if (cursorStyle === 'wait' || cursorStyle === 'auto') {
      state.cursorStyle = cursorStyle;
    }
  },
  [SET_INTERNAL_SUPPLIERS](state, suppliers) {
    state.internalSuppliers = suppliers;
  },
  [SET_GOOGLE_IDS_FOR_ADVERTS](state, googleIds) {
    state.googleIds = googleIds;
  }
};

//getters
const getters = {
  turnaround(state) {
    return _.get(state.config, 'turnaround', 0);
  },
  steelPrice(state) {
    return _.get(state.config, 'steelPrice', 0);
  },
  operationCompletion(state) {
    return state.operationCompletion;
  },
  mainModalActive(state) {
    return state.mainModalActive;
  },
  mainModalText(state) {
    return state.mainModalText;
  },
  showSearchBar(state) {
    return state.showSearchBar;
  },
  isDownloading(state) {
    return state.isDownloading;
  },
  availableInternalSuppliers(state) {
    return state.internalSuppliers;
  },
  mainModalResponse(state) {
    return state.mainModalResponse;
  },
  coPilotAdverts(state) {
    return state.googleIds;
  },
  importerIsLive(state) {
    return state?.config?.programs?.find((element) => element === 'MBSIMPORTER') || null;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}